export class Detalles {
    constructor(nit, fechaRadicacion, mes, anio, nombre, banco, direccion, telefono, telefono2, asesor, leader, codigo, nuevo, estado, pago, seccional, fecha_cu) {
        this.nit = nit;
        this.fechaRadicacion = fechaRadicacion;
        this.mes = mes;
        this.anio = anio;
        this.nombre = nombre;
        this.banco= banco;
        this.direccion = direccion;
        this.telefono = telefono;
        this.telefono2 = telefono2;
        this.asesor = asesor;
        this.leader = leader;
        this.codigo = codigo;
        this.nuevo = nuevo;
        this.estado = estado;
        this.pago = pago;
        this.seccional = seccional;
        this.fecha_cu = fecha_cu;
    }
}